<footer class="section footer-minimal context-dark">
  <div class="container wow-outer">
    <div class="wow fadeIn">
      <div class="row row-60">
        <div class="col-12">
          <ul class="footer-minimal-nav">
            <li><a routerLink="/menu">Menu</a></li>
            <li><a routerLink="/about">Nosotros</a></li>
            <li><a routerLink="/contact">Contacto</a></li>
          </ul>
        </div>

        <div class="col-12">
          <ul class="social-list">
            <!-- <li>
              <a
                href="https://www.instagram.com/bora_tastyfood/"
                target="_blank"
              >
                <i class="fab fa-instagram"></i>
              </a>
            </li> -->
            <li>
              <a href="https://wa.me/5493364517062" target="_blank">
                <i class="fab fa-whatsapp"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p class="rights">
        &copy; {{ year }} Sachacabrona. Todos los derechos reservados.
        <a routerLink="/privacy">Política de Privacidad</a>. Diseño
        original&nbsp;<a
          href="https://www.instagram.com/ivancairoli/"
          target="_blank"
          >Iván Cairoli</a
        >
      </p>
    </div>
  </div>
</footer>
